import { Pillar2AuthType } from '../../model';
import type { Pillar2BffRequest } from './executePillar2Filing';

export interface Pillar2OperationMetadata {
    id: string;
    displayName: string;
    iconName?: string;
}

export interface Pillar2JurisdictionMetadata {
    id: string;
    name: string;
    authType: Pillar2AuthType;
    basePath: string;
    supportedOperations: Pillar2OperationMetadata[];
}

export async function fetchPillar2JurisdictionsMetadata(bff: Pillar2BffRequest): Promise<Pillar2JurisdictionMetadata[]> {
    return (await bff({ url: '/pillar2/jurisdictions', method: 'get' })) as Pillar2JurisdictionMetadata[];
}
